import filter from 'lodash/filter';
import head from 'lodash/head';

export class AboutUsInTheNewsArchiveService {
	constructor($resource, ApiService, DateService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;
		this.dateService = DateService;
		
		this.inTheNewsYearListResourceUrl = this.apiService.getResourceUrl('in-the-news/archive/years');

		this.inTheNewsYearListResource = this.$resource(this.inTheNewsYearListResourceUrl);
	}

	/* #################################### PUBLIC METHODS ######################################### */

	/**
	 * function to get in the news content
	 * @return {object} [information related to in the news]
	 */

	getInTheNewsFilterData({
		year, filterDetails: { limit, pageId }
	}, endPoint) {
		this.inTheNewsFilterResourceUrl = this.apiService.getResourceUrl(`menus/${endPoint}`);
		this.inTheNewsFilterResource = this.$resource(this.inTheNewsFilterResourceUrl);

		const promise = this.inTheNewsFilterResource.get({
			year,
			limit,
			page_id: pageId
		}).$promise;

		return promise.then(details => this._getFilterDetailsObject(details))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	getYearList() {
		const promise = this.inTheNewsYearListResource.get().$promise;

		return promise.then(details => this._getYearData(details.data))
			.catch((error) => {
				throw this.apiService.getErrorMessage(error);
			});
	}

	/* #################################### PRIVATE METHODS ######################################### */
	
	_getNewsDetailsObject(values) {
		let details = filter(values, ['name', 'InTheNews']);
		return _getContentData.call(this,head(details).values);

		function _getContentData(data) {
			return data.map(value => ({
				id: value.content_id,
				nextId: value.next_id,
				previousId: value.previous_id,
				title: value.title,
				description: value.description,
				newsDate: this.dateService.parseDateFromServerDate(value.news_date),
				createdAt: value.publish_at,
				createdBy: value.created_by,
				slug: value.slug
			}));
		}
	}

	_getYearData(data) {
		return data.map(value => ({
			id: value,
			name: value
		}));
	}

	_getFilterDetailsObject(details) {
		let detailsObject = {};
		detailsObject.details = this._getNewsDetailsObject([details.data]);
		if (details.data.hasOwnProperty('count')) {
			detailsObject.count = details.data.count;
		}
		return detailsObject;
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us-in-the-news-archive/about-us-in-the-news-archive.service.js